<template>
	<li class="nav-item">
		<a id="topcart" href="/winkelwagen/" class="c-topbuttons__btn">
			<svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24"><path d="M25.875 3H6.06L5.67.918A1.125 1.125 0 0 0 4.564 0h-4A.563.563 0 0 0 0 .563v.375a.563.563 0 0 0 .563.563h3.69L7.53 18.982A2.989 2.989 0 0 0 6.75 21a3 3 0 0 0 3 3 3 3 0 0 0 3-3 2.983 2.983 0 0 0-.4-1.5h6.8a2.97 2.97 0 0 0-.4 1.493s0 .005 0 .007a3 3 0 0 0 3 3 3 3 0 0 0 3-3 2.99 2.99 0 0 0-.909-2.15A1.126 1.126 0 0 0 22.75 18H8.873l-.563-3h15.533a1.125 1.125 0 0 0 1.1-.9l2.031-9.75A1.125 1.125 0 0 0 25.875 3ZM11.25 21a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 3 0Zm10.5 1.5a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 3 0 1.5 1.5 0 0 1-1.5 1.5Zm1.789-9H8.029l-1.688-9h19.073Z" /></svg>
			<span v-if="amountInBasket > 0" class="position-absolute badge badge-xl">{{ getDisplayAmount(amountInBasket) }}<span class="sr-only">items in de winkelwagen</span></span>
		</a>
	</li>
</template>

<script>
import axios from 'axios';

export default {
	props: {
		authProperties: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			amountInBasket: localStorage.getItem('amountInBasket'),
			isLoggedIn: this.authProperties.isLoggedIn === 'True',
		};
	},
	mounted() {
		window.addEventListener('haenka-basket-changed', event => {
			this.amountInBasket = event.detail.amount;
		});

		const urlParams = new URLSearchParams(window.location.search);

		// check url for "login" and then get the customer-basket
		if (urlParams.has('login'))
		{
			this.basketClient = axios.create({
				baseURL: '/api'
			});
			this.basketClient.defaults.headers.common['Content-Type'] = 'application/json';
			this.basketClient.defaults.timeout = 0;
			this.basketClient.defaults.method = 'post';

			// get customer basket from ABP (via the BasketController)
			this.basketClient
				.post('/winkelwagen/index')
				.then(response => {
					if (response.data != null && response.data !== '' && typeof response.data.BasketItems === 'object' && response.data.BasketItems.length > 0) {
						let totalAmount = 0;
						for (var i = 0, _len = response.data.BasketItems.length; i < _len; i++) {
							totalAmount += response.data.BasketItems[i].Amount;
						}
						this.amountInBasket = totalAmount;
						localStorage.setItem('amountInBasket', totalAmount);
						localStorage.setItem('basketId', response.data.Id);
					}
				})
				.catch(e => {
					// console.error(e);
				});
		}

		// check url for "bedankt" and then clear customer basket
		if (!this.isLoggedIn || window.location.href.endsWith('bestelling-afgerond/'))
		{
			this.amountInBasket = 0;
			localStorage.setItem('amountInBasket', 0);
		}
	},
	methods: {
		getDisplayAmount(amount){
			const amountString = amount + '';
			return amountString.replace('.',',');
		}
	}
};
</script>
